module.exports = __webpack_public_path__ + "img/83.da1db80a.jpg";